module.exports = __webpack_public_path__ + "983d423ee1938fcf1b2615eb038e0966.png";